import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  padding-top: 8px;
`

export const Button = styled.button`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  min-height: 40px;
  padding: 8px 16px;
  border: 1px solid var(--gray200);
  border-radius: 999px;
  background: var(--neutral-theme);
  color: var(--gray500);
  cursor: pointer;
  font: inherit;
  text-align: left;

  &:focus-visible {
    outline: 2px solid var(--primary500);
    outline-offset: 2px;
  }
`

export const Sparkle = styled.span`
  color: var(--primary500);
  font-size: 24px;
  line-height: 1;
`

export const Label = styled.span`
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  min-height: 20px;
`

export const LabelWrapper = styled.span`
  display: flex;
  align-items: center;
  flex: 1;
  overflow: hidden;
`
